<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :model="searchForm" :inline="true" size="mini" ref="searchForm" label-width="100px">
          <el-form-item label="京东SKU编码" prop="sku">
            <el-input v-model="searchForm.sku" @keyup.enter.native="onSearch"></el-input>
          </el-form-item>
          <el-form-item label="限售分类" prop="classificationName">
            <el-select v-model="searchForm.classificationName" clearable @change="onSearch">
              <el-option label="全部" value=""></el-option>
              <el-option :label="item" :value="item" v-for="(item, index) in classificationNameList" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select v-model="searchForm.status" clearable @change="onSearch">
              <el-option label="全部" value=""></el-option>
              <el-option :label="item" :value="item" v-for="(item, index) in ['成功','失败']" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="操作时间" prop="date">
            <form-date-range
              :form="searchForm"
              startKey="createdDateStart"
              endKey="createdDateEnd"
              :usingTime="false"
              valueFormat="yyyy-MM-dd"
            ></form-date-range>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button type="primary" size="mini" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="mini" @click="reset">重置</el-button>
        </template>
      </search-box>
    </template>
    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="small" @click="exportExcel">导出</el-button>
      </template>
      <el-table
        :data="tableData.records"
        ref="tableRef"
        border
        :height="maxTableHeight"
        :cell-style="{ textAlign: 'left' }"
        :header-cell-style="{ textAlign: 'left' }"
        v-loading="loading"
      >
        <el-table-column label="京东SKU编码" prop="sku" min-width="120"></el-table-column>
        <el-table-column label="限售分类" prop="classificationName" min-width="100"></el-table-column>
        <el-table-column label="失败地址" prop="failureAddress" min-width="500" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作时间" prop="createdDate" min-width="160"></el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 60, 90]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
            background
          >
          </el-pagination>
        </div>
      </template>
    </table-panel>
  </content-panel>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin'
import tableMixin from '@/utils/tableMixin';
import moment from 'moment';
export default {
  name: 'restrictedSaleFailureData',
  mixins: [tableMixin, pagePathMixin],
  components: {},
  data() {
    return {
      searchForm: {
        skuList: '',
        sku: '',
        status: '失败',
        classificationName: '',
        createdDateStart: moment().format('YYYY-MM-DD'),
        createdDateEnd: moment().format('YYYY-MM-DD')
      },
      tableHeight: 0,
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      dialogVisible: false,
      rowData: {},
      loading: false,
      all: false,
      isShowAllocation: false,
      isShowImport: false,
      searchFormData: {},
      imgList: [],
      classificationNameList: [],
      orderDto: {},
      queryCriteria: [],
      dialogType: 1,
      timeText: {},
    };
  },
  computed: {},
  mounted() {
    this.onSearch();
    this.getConfigInfoStr();
  },
  methods: {
    onSearch() {
      this.tableData.pageNum = 1;
      this.init();
    },
    async init() {
      this.loading = true;
      let data = {
        filterData: {
          ...this.searchForm,
          skuList: this.searchForm.skuList ? this.searchForm.skuList.split(' ') : [],
        },
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
      };
      this.searchFormData = data;
      this.$q.dataImport
        .skuQueryList({ data: data })
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
            // console.log(res.data.records.map(v=>v.sku).join('\n'));
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      console.log(val);
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init(this.searchFormData);
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      console.log(val);
      this.tableData.pageNum = val;
      this.init(this.searchFormData);
    },
    // 重置
    reset() {
      this.tableData.pageNum = 1;
      this.tableData.pageSize = 30;
      this.$refs.searchForm.resetFields();
      this.onSearch();
    },
    getConfigInfoStr() {
      this.$q.dataImport.getConfigInfoStr().then((res) => {
        this.classificationNameList = res.data;
      });
    },
     // 导出
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let params = {
        appCode: "ec-pc-new",
        paramMap: {
          ...this.searchFormData.filterData,
        },
        reportName: "skuQueryExport",
      };
      this.$q.orderDate.importExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success("提交下载任务成功，请稍后到导出列表查阅！");
        } else {
          this.$message.error(res.message);
        }
      }).finally(_=>{
        loading.close()
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.search-box
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input
      width 240px !important
  >>> .date-range .single-date
    width 110px !important

body
  height: auto !important

.between
  display: flex
  justify-content: space-between
  align-items: center

.panel-in-tab
  >>> .search-outer>div
    padding 0
</style>
<style lang="css">
.el-tooltip__popper {
  max-width: 40%;
}
</style>
